export default "__VITE_ASSET__ZABEzOIh__"